module.exports = __webpack_public_path__ + "img/d2d3e33.jpg";